"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EventDispatcher = (function () {
    function EventDispatcher() {
        this.listeners = [];
    }
    EventDispatcher.prototype.addListener = function (listener) {
        for (var _i = 0, _a = this.listeners; _i < _a.length; _i++) {
            var item = _a[_i];
            if (item === listener) {
                return;
            }
        }
        this.listeners.push(listener);
    };
    EventDispatcher.prototype.removeListener = function (listener) {
        for (var i = 0; i < this.listeners.length; i++) {
            if (this.listeners[i] === listener) {
                this.listeners.splice(i, 1);
                return;
            }
        }
    };
    EventDispatcher.prototype.dispatch = function (event) {
        for (var _i = 0, _a = this.listeners; _i < _a.length; _i++) {
            var item = _a[_i];
            item(event);
        }
    };
    return EventDispatcher;
}());
exports.EventDispatcher = EventDispatcher;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRXZlbnREaXNwYXRjaGVyLmpzIiwic291cmNlUm9vdCI6Ii4vIiwic291cmNlcyI6WyJwZGYvbGliL2dhdGUvRXZlbnREaXNwYXRjaGVyLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQUE7SUFBQTtRQUNZLGNBQVMsR0FBZSxFQUFFLENBQUE7SUEwQnRDLENBQUM7SUF4QlUscUNBQVcsR0FBbEIsVUFBbUIsUUFBa0I7UUFDakMsS0FBaUIsVUFBYyxFQUFkLEtBQUEsSUFBSSxDQUFDLFNBQVMsRUFBZCxjQUFjLEVBQWQsSUFBYyxFQUFFO1lBQTVCLElBQUksSUFBSSxTQUFBO1lBQ1QsSUFBSSxJQUFJLEtBQUssUUFBUSxFQUFFO2dCQUNuQixPQUFNO2FBQ1Q7U0FDSjtRQUVELElBQUksQ0FBQyxTQUFTLENBQUMsSUFBSSxDQUFDLFFBQVEsQ0FBQyxDQUFBO0lBQ2pDLENBQUM7SUFFTSx3Q0FBYyxHQUFyQixVQUFzQixRQUFrQjtRQUNwQyxLQUFLLElBQUksQ0FBQyxHQUFHLENBQUMsRUFBRSxDQUFDLEdBQUcsSUFBSSxDQUFDLFNBQVMsQ0FBQyxNQUFNLEVBQUUsQ0FBQyxFQUFFLEVBQUU7WUFDNUMsSUFBSSxJQUFJLENBQUMsU0FBUyxDQUFDLENBQUMsQ0FBQyxLQUFLLFFBQVEsRUFBRTtnQkFDaEMsSUFBSSxDQUFDLFNBQVMsQ0FBQyxNQUFNLENBQUMsQ0FBQyxFQUFFLENBQUMsQ0FBQyxDQUFBO2dCQUMzQixPQUFNO2FBQ1Q7U0FDSjtJQUNMLENBQUM7SUFFTSxrQ0FBUSxHQUFmLFVBQWdCLEtBQVc7UUFDdkIsS0FBaUIsVUFBYyxFQUFkLEtBQUEsSUFBSSxDQUFDLFNBQVMsRUFBZCxjQUFjLEVBQWQsSUFBYyxFQUFFO1lBQTVCLElBQUksSUFBSSxTQUFBO1lBQ1QsSUFBSSxDQUFDLEtBQUssQ0FBQyxDQUFBO1NBQ2Q7SUFDTCxDQUFDO0lBQ0wsc0JBQUM7QUFBRCxDQUFDLEFBM0JELElBMkJDO0FBM0JZLDBDQUFlIn0=